// services/locationTypesApi.ts
import api from './api';
import { LocationType, CreateLocationTypeRequest, UpdateLocationTypeRequest } from '../types/locationTypes';

export const locationTypesApi = {
    getAllLocationTypes: async (): Promise<LocationType[]> => {
        const response = await api.get('/locationtypes');
        return response.data;
    },

    getLocationType: async (id: number): Promise<LocationType> => {
        const response = await api.get(`/locationtypes/${id}`);
        return response.data;
    },

    createLocationType: async (locationType: CreateLocationTypeRequest): Promise<LocationType> => {
        const response = await api.post('/locationtypes', locationType);
        return response.data;
    },

    updateLocationType: async (id: number, locationType: UpdateLocationTypeRequest): Promise<void> => {
        await api.put(`/locationtypes/${id}`, locationType);
    },

    deleteLocationType: async (id: number): Promise<void> => {
        await api.delete(`/locationtypes/${id}`);
    }
};